<div class="item-title">{{title}}</div>
<div class="item-content">    
    <template [ngTemplateOutlet]="template"></template>
</div>
